import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/pdfWhite.svg'
import _imports_1 from '@/assets/img/management/requests.svg'
import _imports_2 from '@/assets/img/management/denied.svg'
import _imports_3 from '@/assets/img/management/invite.svg'
import _imports_4 from '@/assets/img/management/edit.svg'
import _imports_5 from '@/assets/img/management/settings.svg'


const _hoisted_1 = { class: "hasAdminButtonsFooter" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "fs_13 black" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "fs_13 black" }
const _hoisted_8 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "fs_13 black" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = {
  key: 0,
  class: "fs_13 black"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { class: "fs_13 black" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "fs_13 black" }
const _hoisted_19 = {
  key: 1,
  class: "row"
}
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "fs_13 black" }
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = { class: "fs_13 black" }
const _hoisted_24 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_25 = { class: "fs_13 black" }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { class: "pre mt-3" }
const _hoisted_28 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_29 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_30 = { class: "fs_13 greyBlue text-uppercase" }
const _hoisted_31 = { class: "galleriesContainer mt-2" }
const _hoisted_32 = { class: "fs_12 white mt-1 pdfName imageName" }
const _hoisted_33 = {
  key: 0,
  src: _imports_0,
  class: "mb-1"
}
const _hoisted_34 = { class: "d-flex align-items-center justify-content-between mt-3" }
const _hoisted_35 = { class: "fs_13 greyBlue text-uppercase" }
const _hoisted_36 = { class: "galleriesContainer mt-2" }
const _hoisted_37 = { class: "d-flex align-items-center justify-content-between mt-3" }
const _hoisted_38 = { class: "fs_13 greyBlue text-uppercase" }
const _hoisted_39 = { class: "reteContainer m-0 mt-2" }
const _hoisted_40 = { class: "reteImage" }
const _hoisted_41 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_42 = { class: "fs-14 text-cyan" }
const _hoisted_43 = { class: "reteContainer mt-2" }
const _hoisted_44 = { class: "reteItem" }
const _hoisted_45 = { class: "reteImage gonfia" }
const _hoisted_46 = { class: "reteName" }
const _hoisted_47 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_48 = { class: "d-flex flex-wrap" }
const _hoisted_49 = {
  key: 4,
  class: "adminButtonContainer"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_51 = { class: "notifications" }
const _hoisted_52 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)

export function render(_ctx: any,_cache: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_swiper_slides = _resolveComponent("swiper-slides")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isFiera)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_dal",
                text: "Dal",
                class: "fs_13 greyBlue text-uppercase d-block"
              }),
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$filters.date(_ctx.updatedCommunity.dateFrom, "DD/MM/YYYY")), 1)
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_al",
                text: "Al",
                class: "fs_13 greyBlue text-uppercase d-block"
              }),
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$filters.date(_ctx.updatedCommunity.dateTo, "DD/MM/YYYY")), 1)
            ])
          ]),
          (_ctx.updatedCommunity.openFrom && _ctx.updatedCommunity.openTo)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_orari",
                    text: "Orari",
                    class: "fs_13 greyBlue text-uppercase d-block"
                  }),
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.updatedCommunity.openFrom) + " / " + _toDisplayString(_ctx.updatedCommunity.openTo), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_contatti",
              text: "Contatti",
              class: "fs_13 greyBlue text-uppercase d-block"
            }),
            (!_ctx.updatedCommunity.contatti)
              ? (_openBlock(), _createBlock("span", _hoisted_12, "-"))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: "pre mt-2 pr-3 fs_13 black",
              innerHTML: _ctx.updatedCommunity.contatti
            }, null, 8, ["innerHTML"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isEvent)
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_dal",
                text: "Dal",
                class: "fs_13 greyBlue text-uppercase d-block"
              }),
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$filters.date(_ctx.updatedCommunity.dateFrom, "DD/MM/YYYY - HH:mm")), 1)
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_al",
                text: "Al",
                class: "fs_13 greyBlue text-uppercase d-block"
              }),
              _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$filters.date(_ctx.updatedCommunity.dateTo, "DD/MM/YYYY - HH:mm")), 1)
            ])
          ]),
          (_ctx.updatedCommunity.openFrom && _ctx.updatedCommunity.openTo)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 0,
                localizedKey: "app_oraridiapertura",
                text: "Orari di apertura:",
                class: "fs_13 greyBlue text-uppercase d-block mt-3"
              }))
            : _createCommentVNode("", true),
          (_ctx.updatedCommunity.openFrom && _ctx.updatedCommunity.openTo)
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_dalle",
                    text: "Dalle",
                    class: "fs_13 greyBlue text-uppercase d-block"
                  }),
                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.updatedCommunity.openFrom), 1)
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_alle",
                    text: "Alle",
                    class: "fs_13 greyBlue text-uppercase d-block"
                  }),
                  _createVNode("span", _hoisted_23, _toDisplayString(_ctx.updatedCommunity.openTo), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.updatedCommunity.isOnlineEvent && _ctx.updatedCommunity.address)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_indirizzo",
                  text: "Indirizzo",
                  class: "fs_13 greyBlue text-uppercase d-block"
                }),
                _createVNode("span", _hoisted_25, _toDisplayString(_ctx.updatedCommunity.address ? _ctx.updatedCommunity.address : "-"), 1)
              ]))
            : (_ctx.updatedCommunity.isOnlineEvent)
              ? (_openBlock(), _createBlock("div", _hoisted_26, [
                  _createVNode(_component_localized_text, {
                    class: "fs_13 black",
                    localizedKey: "app_leventosisvolgeraonline",
                    text: "L\\'evento si svolgerà online"
                  })
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_27, [
      _createVNode("span", {
        innerHTML: _ctx.updatedCommunity.description,
        class: "fs_14 greyBlue ws-preline"
      }, null, 8, ["innerHTML"])
    ]),
    (!_ctx.isFiera)
      ? (_openBlock(), _createBlock("div", _hoisted_28, [
          (_ctx.allegati.length > 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_allegati",
                      text: "Allegati",
                      class: "fs_13 greyBlue text-uppercase"
                    }),
                    _createTextVNode(" (" + _toDisplayString(_ctx.allegati.length) + ") ", 1)
                  ]),
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_veditutti",
                    text: "Vedi tutti",
                    class: "fs_12 greyBlue text-uppercase",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openAllegatiModal()))
                  })
                ]),
                _createVNode("div", _hoisted_31, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allegati, (item, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "galleryItem",
                      key: item.identifier,
                      onClick: ($event: any) => (_ctx.openAllegatiModal(i)),
                      style: 'background-image: url(' + _ctx.getAttachmentBackImage(item.preview) + ');'
                    }, [
                      _createVNode("span", _hoisted_32, [
                        (item.preview.indexOf('icon_pdf') > -1)
                          ? (_openBlock(), _createBlock("img", _hoisted_33))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.title), 1)
                      ])
                    ], 12, ["onClick"]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.updatedCommunity.gallery.length > 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode("div", _hoisted_34, [
                  _createVNode("div", _hoisted_35, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_gallery",
                      text: "Gallery",
                      class: "fs_13 greyBlue text-uppercase"
                    }),
                    _createTextVNode(" (" + _toDisplayString(_ctx.updatedCommunity.gallery.length) + ") ", 1)
                  ]),
                  _createVNode(_component_localized_text, {
                    localizedKey: 'app_veditutte',
                    text: 'Vedi tutte',
                    class: "fs_12 greyBlue text-uppercase",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openMediaModal()))
                  })
                ]),
                _createVNode("div", _hoisted_36, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.updatedCommunity.gallery, (item, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "galleryItem",
                      key: i,
                      onClick: ($event: any) => (_ctx.openMediaModal(i)),
                      style: 'background-image: url(\'' + item + '\');'
                    }, null, 12, ["onClick"]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.updatedCommunity.admins.length > 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                _createVNode("div", _hoisted_37, [
                  _createVNode("span", _hoisted_38, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_amministratori",
                      text: "Amministratori",
                      class: "fs_13 greyBlue"
                    }),
                    _createTextVNode(" (" + _toDisplayString(_ctx.updatedCommunity.admins.length) + ") ", 1)
                  ]),
                  _createVNode(_component_localized_text, {
                    class: "fs_12 greyBlue text-uppercase",
                    localizedKey: "app_veditutti",
                    text: "Vedi tutti",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPeopleModal(_ctx.updatedCommunity.admins)))
                  })
                ]),
                _createVNode("div", _hoisted_39, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.updatedCommunity.admins, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "reteItem",
                      key: item.identifier + '_selected',
                      onClick: ($event: any) => (_ctx.openPerson(item))
                    }, [
                      _withDirectives(_createVNode("div", _hoisted_40, null, 512), [
                        [_directive_userimage, _ctx.$store.state.getUserImage(item.identifier)]
                      ])
                    ], 8, ["onClick"]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.updatedCommunity.moderators.length > 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                _createVNode("div", _hoisted_41, [
                  _createVNode("div", _hoisted_42, [
                    _createVNode(_component_localized_text, {
                      class: "text_uppercase",
                      localizedKey: "app_moderatori",
                      text: "Moderatori"
                    })
                  ]),
                  _createVNode("div", {
                    class: "fs-14 pointer",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openPeopleModal(_ctx.updatedCommunity.moderators)))
                  }, [
                    _createVNode(_component_localized_text, {
                      class: "text_uppercase",
                      localizedKey: "app_veditutti",
                      text: "Vedi tutti"
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_43, [
                  _createVNode(_component_swiper_slides, {
                    class: "reteContainer mt-2",
                    showPagination: false,
                    arrow: true
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.updatedCommunity.moderators, (item) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "swiper-slide w_75",
                          key: item.identifier,
                          onClick: ($event: any) => (_ctx.openPerson(item))
                        }, [
                          _createVNode("div", _hoisted_44, [
                            _withDirectives(_createVNode("div", _hoisted_45, null, 512), [
                              [_directive_userimage, _ctx.$store.state.getUserImage(item.identifier)]
                            ]),
                            _createVNode("div", _hoisted_46, _toDisplayString(item.name), 1)
                          ])
                        ], 8, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.updatedCommunity.isLiked)
      ? (_openBlock(), _createBlock("div", _hoisted_47, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_notifiche",
            text: "Notifiche",
            class: "fs_13 greyBlue text-uppercase d-block mb-2"
          }),
          _createVNode("div", _hoisted_48, [
            _createVNode("div", {
              class: ["filterTab px-4", _ctx.updatedCommunity.isSubscribed ? 'active' : ''],
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setSubscribtion(true)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_si",
                text: "Si",
                class: "fs_12 d-block"
              })
            ], 2),
            _createVNode("div", {
              class: ["filterTab px-4", !_ctx.updatedCommunity.isSubscribed ? 'active' : ''],
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setSubscribtion(false)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_no",
                text: "No",
                class: "fs_12 d-block"
              })
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.updatedCommunity.canSettings || _ctx.updatedCommunity.canInfo)
      ? (_openBlock(), _createBlock("div", _hoisted_49, [
          _createVNode("div", {
            class: "managementButton",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openUserRequest()))
          }, [
            _hoisted_50,
            _createVNode("div", _hoisted_51, _toDisplayString(_ctx.requests.length), 1)
          ]),
          _createVNode("div", {
            class: "managementButton",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openUsersBlockedModal()))
          }, [
            _hoisted_52
          ]),
          _createVNode("div", {
            class: "managementButton",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openInviteUser()))
          }, [
            _hoisted_53
          ]),
          _createVNode("div", {
            class: "managementButton",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openEditModal()))
          }, [
            _hoisted_54
          ]),
          _createVNode("div", {
            class: "managementButton",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openSettingsModal()))
          }, [
            _hoisted_55
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}